import {
  useDebugValue,
  useEffect,
  useMemo,
  useState,
} from 'react';

import { loadStripe } from '@stripe/stripe-js';
import { Elements, CardElement, useStripe, useElements, PaymentElement } from '@stripe/react-stripe-js';

import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';

import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';

import { useAuth } from 'react-oidc-context';
import { Modal } from 'react-bootstrap';
import { Button, CircularProgress, Step, StepLabel, Stepper, styled, ToggleButton, ToggleButtonGroup, toggleButtonGroupClasses, Tooltip, Typography } from '@mui/material';

import {
  getStripePublishableKey,
} from '../../types/stripe';

const STRIPE_PUBLISHABLE_KEY = await getStripePublishableKey();

const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
  [`& .${toggleButtonGroupClasses.grouped}`]: {
    display: 'flex',
    flex: 1,
    width: '100%',
    margin: '0.6vw!important',
    border: 0,
    borderRadius: theme.shape.borderRadius,
    backgroundColor: 'rgb(0, 0, 0, 0.03)',
    [`&.${toggleButtonGroupClasses.disabled}`]: {
      border: 0,
    },
    [`&.${toggleButtonGroupClasses.selected}`]: {
      backgroundColor: 'rgb(255, 255, 255, 0.6)',
    },
  },
  [`& .${toggleButtonGroupClasses.middleButton},& .${toggleButtonGroupClasses.lastButton}`]:
    {
      marginLeft: -1,

      borderLeft: '1px solid transparent',
    },
}));

const stripePromise = loadStripe(STRIPE_PUBLISHABLE_KEY);

export default function Subscribe({ show, closeHandler, reloadHandler, plans, paygPlans, selectedFixedPlan, currentPaygRange, currentPlan, currentNoClients, availablePlanTypes }) {
  const [
    isProcessing,
    setIsProcessing,
  ] = useState(false);

  const [
    subscriptionStatus,
    setSubscriptionStatus,
  ] = useState('pending');

  const auth = useAuth();

  const [
    clientSecret,
    setClientSecret,
  ] = useState('');

  const [
    sessionExpired,
    setSessionExpired,
  ] = useState(false);

  const [
    outcomeStatus,
    setOutcomeStatus,
  ] = useState();

  const [
    planType,
    setPlanType,
  ] = useState('payg');

  async function subscribe(priceId) {
    setIsProcessing(true);

    fetch(`${window.origin}/api/stripe/session`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth.user?.access_token}`,
      },
      body: JSON.stringify({
        email: auth.user?.profile?.email,
        quantity: currentNoClients,
        priceId: priceId,
        subscriptionType: 'business',
      }),
    }).then((response) => {
      if (response.status === 403) {
        setSessionExpired(true);
        throw new Error('Session expired');
      }

      return response.json();
    }).then((data) => {
      console.log(data);

      let subscriptionId = data.subscriptionId;

      console.log(subscriptionId);

      setSubscriptionStatus('pending');

      let intervalId = setInterval(() => {
        fetch(`${window.origin}/api/stripe/subscription/${subscriptionId}`, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth.user?.access_token}`,
          },
        }).then((response) => {
          if (response.status === 403) {
            setSessionExpired(true);
            throw new Error('Session expired');
          }

          return response.json();
        }).then((data) => {
          console.log(data);

          let subStat = data.subscription_status;

          if (subStat != 'pending') {
            setSubscriptionStatus(subStat);
            clearInterval(intervalId);
          }
        });
      }, 100);
    }).catch((error) => {
      setIsProcessing(false);
      setOutcomeStatus('error');
      // setSnackBarMessage('Unknown error occurred, Please try again later')
      // setSnackBarShow(true)
    });
  }

  useEffect(() => {
    if (subscriptionStatus == 'active') {
      reloadHandler();
      setIsProcessing(false);

      setOutcomeStatus(null);
    }
  }, [subscriptionStatus]);

  useEffect(() => {
    if (currentPlan?.planType == 'Fixed Price') {
      setPlanType('fixed');
    } else {
      setPlanType('payg');
    }
  }, [currentPlan]);

  return (
    <>
      <Modal
        show={show}
        onHide={closeHandler}
        dialogClassName="modal-70w"
        aria-labelledby="example-custom-modal-styling-title"
      >

        <Modal.Body style={{ padding: '2vw 3vw', paddingBottom: '0vw', textAlign: 'center', color: 'rgb(0, 15, 30, 0.8)' }}>
          <h4 style={{ textAlign: 'center', fontSize: '1.3vw', marginBottom: '1vw', fontWeight: '600' }}>Subscription</h4>
          <p style={{ margin: 0, marginBottom: '2vw', fontWeight: '300', fontSize: '0.8vw', padding: '0 2vw', color: 'rgb(0, 15, 30, 0.7)' }}>Select the payment plan that suits you</p>
          <div style={{ display: 'flex', textAlign: 'center', padding: '0.2rem', backgroundColor: 'rgb(255, 255, 255, 0)', margin: '0 1vw', borderRadius: '1vw' }}>
            <StyledToggleButtonGroup
              value={planType}
              exclusive
              onChange={(event, newValue) => {
                if (newValue !== null) {
                  setPlanType(newValue);
                }
              }}
            >

              {plans.map((plan, index) => (
                <ToggleButton
                  value={plan.plan_id}
                  key={index}
                  style={{ alignItems: 'flex-start', textAlign: 'left', flexDirection: 'column', padding: '1.5vw', flex: 1, textAlign: 'left', borderRadius: '0.6vw', margin: '0', marginRight: index != plans.length - 1 ? '0.75vw' : 0, cursor: 'pointer', ...selectedFixedPlan.plan_id == plan.plan_id ? selectedStyle : {} }}
                >
                  <p style={{ fontSize: '1.3vw', fontWeight: '500', marginBottom: '1.1vw', marginTop: '0.5vw' }}>{plan.plan_name}</p>
                  <p style={{ textAlign: 'left', fontSize: '0.7vw', height: '5.5vw', margin: 0 }}>{plan.description}</p>
                  <p>
                    {plan.plan_id == 'payg'
                      ? (
                          <>
                            <span style={{ fontWeight: '500', fontSize: '1.2vw' }}>$2</span>
                            <span style={{ fontWeight: '500', fontSize: '0.8vw' }}> per client/month</span>
                          </>
                        )
                      : (
                          <>
                            <span style={{ fontWeight: '500', fontSize: '1.2vw' }}>$3,000</span>
                            <span style={{ fontWeight: '500', fontSize: '0.8vw' }}> /month</span>
                          </>
                        )}
                  </p>

                </ToggleButton>
              ),
              )}
            </StyledToggleButtonGroup>

          </div>

          <div style={{ marginTop: '1vw', marginBottom: '2vw' }}>
            { planType == 'fixed' && (
              <>

                { !outcomeStatus && !isProcessing && (
                  <Button
                    onClick={() => { subscribe(availablePlanTypes?.flatRate?.stripe_price?.id); }}
                    disabled={currentPlan?.planType == 'Fixed Price' ? true : false}
                    variant="outlined"
                    style={{
                      borderColor: 'rgb(255, 255, 255, 1)', color: 'rgb(255, 255, 255, 0.9)', padding: '0.7vw', marginBottom: '1vw', border: 'none', backgroundImage: 'linear-gradient(rgb(255, 255, 255, 0.05), rgb(10, 10, 10, 0.05)),linear-gradient(#1c6c6c, #1c6c6c)', borderRadius: '0.5vw', textTransform: 'none', fontSize: '1vw', fontWeight: 500, letterSpacing: '0.08vw',
                      width: '40%', marginTop: '1vw' }}
                  >
                    {currentPlan?.planType == 'Fixed Price' ? 'Subscribed' : 'Subscribe'}
                  </Button>
                )}

                { outcomeStatus == 'sucess' && !isProcessing && (
                  <div style={{ padding: '1vw' }}>
                    <CheckCircleOutlineOutlinedIcon style={{ fontSize: '3vw', color: 'green' }} />
                  </div>
                )}

                { outcomeStatus == 'error' && !isProcessing && (
                  <div style={{ padding: '1vw' }}>
                    <CancelOutlinedIcon style={{ fontSize: '3vw', color: 'red' }} />
                  </div>
                )}

                { isProcessing && (
                  <div style={{ padding: '1vw' }}>
                    <CircularProgress style={{ color: 'rgb(28, 108, 108)' }} />
                  </div>
                )}
              </>
            )}
            { planType == 'payg' && (
              <>

                { !outcomeStatus && !isProcessing && (
                  <Button
                    onClick={() => { subscribe(availablePlanTypes?.payg?.stripe_price?.id); }}
                    disabled={currentPlan?.planType == 'Pay-as-you-go' ? true : false}
                    variant="outlined"
                    style={{
                      borderColor: 'rgb(255, 255, 255, 1)', color: 'rgb(255, 255, 255, 0.9)', padding: '0.7vw', marginBottom: '1vw', border: 'none', backgroundImage: 'linear-gradient(rgb(255, 255, 255, 0.05), rgb(10, 10, 10, 0.05)),linear-gradient(#1c6c6c, #1c6c6c)', borderRadius: '0.5vw', textTransform: 'none', fontSize: '1vw', fontWeight: 500, letterSpacing: '0.08vw',
                      width: '40%', marginTop: '1vw' }}
                  >
                    {currentPlan?.planType == 'Pay-as-you-go' ? 'Subscribed' : 'Subscribe'}
                  </Button>
                )}

                { outcomeStatus == 'sucess' && !isProcessing && (
                  <div style={{ padding: '1vw' }}>
                    <CheckCircleOutlineOutlinedIcon style={{ fontSize: '3vw', color: 'green' }} />
                  </div>
                )}

                { outcomeStatus == 'error' && !isProcessing && (
                  <div style={{ padding: '1vw' }}>
                    <CancelOutlinedIcon style={{ fontSize: '3vw', color: 'red' }} />
                  </div>
                )}

                { isProcessing && (
                  <div style={{ padding: '1vw' }}>
                    <CircularProgress style={{ color: 'rgb(28, 108, 108)' }} />
                  </div>
                )}
              </>
            )}

          </div>

        </Modal.Body>
      </Modal>

    </>
  );
}

const selectedStyle = {
  backgroundColor: 'rgba(28, 108, 108, 0.9)',
  color: 'rgb(255, 255, 255, 0.9)',

};

